<!-- =================================================
 Vue Template
================================================== -->
<template>
  <div class="discover">
    <div class="row landing-design">
      <div class="hidden-xs col-md-1"></div>
      <div class="col-12 col-md-5" style="padding-top:80px">
        <h1 class="title-landing">"Coming together is a beginning, staying together is progress, and working together is success." – Henry Ford</h1>
        <h1 class="subtitle-landing">Our Stength is the team, technology does the rest.</h1>
      </div>
      <div class="col-12 col-md-6" style="text-align:center">
        <img :src="app_twill" style="width:90%">
      </div>
    </div>

    <div class="row row-1 ligne-discover">
      <div class="col-md-4" style="text-align:center">
        <img :src="vue" style="width:80%;padding-top:15px;">
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-7">
        <h1 class="title-landing-2">For the Web : Vue.JS</h1>
        <h1 class="subtitle-landing-2">&nbsp;&nbsp;&nbsp;Vue.js is a great framework! It has a friendly
            learning curve and combines the best of React’s component approach and Angular’s templates.<br><br>
            &nbsp;&nbsp;&nbsp;The open-source JavaScript front-end framework was built to organize and simplify web development.
            The project focuses on making ideas in web UI development (components, declarative UI, hot-reloading, time-travel debugging, etc.) more approachable.     
        </h1>
      </div>
      <div class="col-12 col-md-12" style="text-align:center;">
        <img :src="hr" style="width:80%;">
      </div>
    </div>

    <div class="row row-1 ligne-discover">
      <div class="col-12 hidden-md" style="text-align:center">
        <img :src="react" style="width:80%;padding-top:0px;">
      </div> 
      <div class="col-md-1"></div>   
      <div class="col-md-7">
        <h1 class="title-landing-2">For mobile : React + Redux</h1>
        <h1 class="subtitle-landing-2">&nbsp;&nbsp;&nbsp;React Native is a JavaScript framework for writing real, natively mobile applications for iOS and Android. It’s based on React, the Facebook JavaScript library for building user interfaces, but instead of targeting the browser, it targets mobile platforms. <br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Used by Facebook itself and other bit companies like Netflix, it is known as the best technology in the market to develop native application.<br><br> 
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Using Redux on top of React native is making our apps way more powerful than it alreadfy is. Indeed, thanks to Redux framework, we take full control of data and makes our apps faster.<br><br> 
          </h1>
      </div>
      <div class="hidden-xs col-md-4" style="text-align:center">
        <img :src="react" style="width:70%;padding-top:65px;">
      </div>   
      <div class="col-12 col-md-12" style="text-align:center;">
        <img :src="hr" style="width:80%;">
      </div> 
    </div>

    <div class="row row-1 ligne-discover">
      <div class="col-12 hidden-md" style="text-align:center">
        <img :src="firebase" style="width:80%;padding-top:0px;">
      </div> 
      <div class="hidden-xs col-md-4" style="text-align:center">
        <img :src="firebase" style="width:80%;padding-top:85px;">
      </div>      
      <div class="col-md-7">
        <h1 class="title-landing-2">The Database : Firebase</h1>
        <h1 class="subtitle-landing-2">&nbsp;&nbsp;&nbsp;Firebase is a Backend-as-a-Service — BaaS — that started as a YC11 startup 
          and grew up into a next-generation app-development platform on Google Cloud Platform.<br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;It's a real-time database.<br><br> 
          &nbsp;&nbsp;&nbsp;&nbsp;Real-time data is the way of the future. Nothing compares to it.

          Most databases require you to make HTTP calls to get and sync your data. Most databases give you data only when you ask for it.<br>

          When you connect your app to Firebase, you’re not connecting through normal HTTP. You’re connecting through a WebSocket. WebSockets are much, much faster than HTTP. 
          You don’t have to make individual WebSocket calls, because one socket connection is plenty. All of your data syncs automagically through that single WebSocket as fast as your client’s network can carry it.   <br><br>

          &nbsp;&nbsp;&nbsp;&nbsp;Firebase sends you new data as soon as it’s updated. All connected clients receive the updated data almost instantly as soon as your client saves a change to the data,.
        </h1>
      </div>
      <div class="col-md-1"></div>
      <div class="col-12 col-md-12" style="text-align:center;">
        <img :src="hr" style="width:80%;">
      </div> 
    </div>

    <div class="row row-1 ligne-discover">
      <div class="col-md-1"></div>
      <div class="col-12 hidden-md" style="text-align:center">
        <img :src="stripe" style="width:40%;padding-top:15px;">
      </div>
      <div class="col-md-7">
        <h1 class="title-landing-2">Secure payments : Stripe</h1>
        <h1 class="subtitle-landing-2">&nbsp;&nbsp;&nbsp;Stripe is a developper tool that can be use to integrate fast and secure payments processing onto websites and mobile applications.
        Ranked number one in the prestigious Forbes Cloud 100, Stripe is the reference in terms of online payments.
        </h1>
      </div>
      <div class="hidden-xs col-md-4" style="text-align:center">
        <img :src="stripe" style="width:40%;padding-top:15px;">
      </div>

      <div class="col-12 col-md-12" style="text-align:center;">
        <img :src="hr" style="width:80%;">
      </div>
    </div>

    <div class="row row-1 ligne-discover">
      <div class="col-md-4" style="text-align:center">
        <img :src="sketch" style="width:40%;padding-top:15px;">
      </div>
      <div class="col-md-7">
        <h1 class="title-landing-2">The Design : Sketch</h1>
        <h1 class="subtitle-landing-2">&nbsp;&nbsp;&nbsp;Twill studio's designers are using the best open source source tool for digital graphic designers.
        This tool allow us to produce powerful annimated prototypes in the fastest time recorded.
        </h1>
      </div>
      <div class="col-md-1"></div>

      <div class="col-12 col-md-12" style="text-align:center;">
        
      </div>
    </div>


  </div>
</template>

<!-- =================================================

        Discover Twill<br>
        We combine the best technologies to make your users happy to use your product.<br>
        vue JS + Firebase + Sketch

 Vue Script
================================================== -->
<script>
export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    wave: require('./assets/img/app/wave.svg'),
    app_twill: require('./assets/img/app/app_twill.png'),
    landing_web: require('./assets/img/website/landing_web.png'),
    vue: require('./assets/img/discover/vue.png'),
    firebase: require('./assets/img/discover/firebase.png'),
    react: require('./assets/img/discover/react.jpg'),
    stripe: require('./assets/img/discover/stripe.png'),
    sketch: require('./assets/img/discover/sketch.png'),
    hr: require('./assets/img/discover/hr.svg'),
    show_contact_form: this.$parent.show_contact_form,
    tick: require('./assets/img/price/tick.svg')
  }
  },
    methods: {
      data_to_app: function data_to_app() {
        this.$emit('openContact');
        console.log('yesssss');
      }
  }
}
</script>

<!-- =================================================
 Vue Style
================================================== -->
<style scoped>
/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}

.landing-design{
  height:auto;
  width:100%;
  margin-left:0px;
  padding-top:70px;
  position: relative;
  z-index:10px;
/* Rectangle: */
background-image: linear-gradient(45deg, #FBC79A 0%, #D73E68 100%);
}
.ligne-discover{
  background-color:white;
  height:auto;
  padding-top:30px;
  margin-top: -5px;
}
}


/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}

.landing-design{
  height:100vh;
  width:100%;
  margin-left:0px;
  padding-top:150px;
  position: relative;
  z-index:10px;
/* Rectangle: */
background-image: linear-gradient(45deg, #FBC79A 0%, #D73E68 100%);
}
.ligne-discover{
  background-color:white;
  height:auto;
  padding-top:30px;
  margin-top: -5px;
}
}

.title-landing-2{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(87, 87, 87);
font-size:34px;
font-weight:normal;  
text-align:center;

}

.subtitle-landing-2{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(129, 129, 129);
font-size:25px;
font-weight:normal;  
margin-bottom:30px;
text-align: justify;
padding-top:7px;
line-height: 1.4;
}

.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}
.subtitle-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(201, 198, 198);
font-size:30px;
font-weight:normal;  
}
.row-1{
  width:100%;
  margin-left:0;
}
</style>


// WEBPACK FOOTER //
// src/discover.vue